import { createFileRoute } from "@tanstack/react-router";
import { EnEsperaCfdiPage } from "@/features/en-espera-cfdi/components/EnEsperaCfdiPage";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";

/**
 * Ruta `/contrapagos-pendientes` · P44 FB60 Contrapago · bandeja de
 * solicitudes Autorizadas en espera del CFDI real. Hotspot 87 · mismo permiso
 * que el menú y el endpoint (`contrapagos.gestionar`): sin él, aviso de acceso
 * restringido en vez de una tabla vacía por un 403.
 */
export const Route = createFileRoute("/_authed-tw/contrapagos-pendientes")({
  component: () => (
    <PermissionGate permisos={[PERMISOS.contrapagosGestionar]}>
      <EnEsperaCfdiPage />
    </PermissionGate>
  ),
});
